module.exports = __webpack_public_path__ + "static/img/1805_2.dac6463.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1805_2.jpg
// module id = fMEx
// module chunks = 1